import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        if (sid) {
          await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        }
        window.history.replaceState(null, "", "/dashboard");
        await refresh();
        nav("/dashboard", { replace: true });
      } catch {
        nav("/auth", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-su-bg">
      <div className="flex flex-col items-center gap-4">
        <div className="w-14 h-14 rounded-full border-4 border-su-border border-t-su-primary animate-spin" />
        <p className="font-heading font-extrabold text-su-muted">Menyiapkan markasmu...</p>
      </div>
    </div>
  );
}
